import { useState } from 'react';
import { Collapse } from 'react-bootstrap';

interface IProps {
    title: string;
    content: JSX.Element | JSX.Element[] | string;
}

export const CardComponent = (props: IProps) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <div className="col-12 pt-3">
            <div className="card">
                <div className="card-header fondoSeccion" onClick={() => { setOpen(!open) }}>
                    <h6>{props.title}</h6>
                    <i className={`fa-solid fa-play ${open ? 'iconShow' : 'iconNotShow'}`} />
                </div>
                <Collapse in={open}>
                    <div className="card-body">
                        {props.content}
                    </div>
                </Collapse>
            </div>
        </div>
    );
}